import api from "./client";

export interface RegisterData {
  organizationName: string;
  email: string;
  password: string;
  fullName: string;
}

export interface LoginData {
  email: string;
  password: string;
}

export interface AuthResponse {
  user: {
    id: string;
    email: string;
    full_name: string;
    role: string;
    organization_id: string;
  };
  organization: {
    id: string;
    name: string;
  };
  accessToken: string;
  refreshToken: string;
}

export interface UserProfile {
  id: string;
  email: string;
  full_name: string;
  role: string;
  organization_id: string;
  organization_name: string;
  created_at: string;
}

export async function register(data: RegisterData): Promise<AuthResponse> {
  const response = await api.post("/api/auth/register", data);
  return response.data;
}

export async function login(data: LoginData): Promise<AuthResponse> {
  const response = await api.post("/api/auth/login", data);
  return response.data;
}

export async function getProfile(): Promise<UserProfile> {
  const response = await api.get("/api/auth/profile");
  return response.data;
}

export async function refreshToken(refreshToken: string): Promise<{ accessToken: string }> {
  const response = await api.post("/api/auth/refresh-token", { refreshToken });
  return response.data;
}

export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  await api.post("/api/auth/change-password", {
    currentPassword,
    newPassword,
  });
}
